import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ScraperProgressState } from '.';

export const selectStudyDataState = createFeatureSelector<ScraperProgressState>('scraper');

export const selectScraperProgress = createSelector(selectStudyDataState, (study) => study.progress);

export const selectScraperProgressByStudy = (studyId: number) => createSelector(selectScraperProgress, (sp) => (sp ? sp[studyId] : null));

export const selectScraperProgressStatusByStudy = (studyId: number) =>
  createSelector(selectScraperProgressByStudy(studyId), (sp) => (sp ? sp.status : null));

export const selectScraperProgressComparablesStatusByStudy = (studyId: number) =>
  createSelector(selectScraperProgressByStudy(studyId), (sp) => (sp ? sp.comparableIds : null));

export const selectScraperDebuggingInfoByStudy = (studyId: number) =>
  createSelector(selectScraperProgressByStudy(studyId), (sp) => (sp ? sp.debugInfo : null));

export const selectIsDownloadAvailableByStudy = (studyId: number) =>
  createSelector(selectScraperProgressByStudy(studyId), (sp) => (sp ? sp.isDownloadAvailable : null));
